import request from '@/router/axios'
import env from '@/config/env'
// 获取今日数据
export const getTodayData = (params) => {
  return request({
    url: env.ferryUrl + '/platform-date-analysis/today-data',
    method: 'GET',
    params
  })
}
// 营收top10
export const getTenGmv = (params) => {
  return request({
    url: env.ferryUrl + '/platform-date-analysis/revenue',
    method: 'GET',
    params
  })
}
// 退票率
export const getTenRefund = (params) => {
  return request({
    url: env.ferryUrl + '/platform-date-analysis/refund',
    method: 'GET',
    params
  })
}
// 用户概况
export const getUserSummary = () => {
  return request({
    url: env.ferryUrl + '/user/userOverview',
    method: 'POST'
  })
}

// 新增用户数据 yearList
export const getNewUser = (data) => {
  return request({
    url: env.ferryUrl + '/user/newUserData',
    method: 'POST',
    data
  })
}
// 平台营收情况 yearList
export const getRevenueOverview = (data) => {
  return request({
    url: env.ferryUrl + '/operation-report/platform-revenue-overview',
    method: 'POST',
    data
  })
}
